import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// common data
import bk from '../../_common/data/bk';
import client from '../../_common/data/client';
import content from '../../_common/data/content';
import covid from '../../_common/data/covid';
import currencies from '../../_common/data/currencies';
import flg from '../../_common/data/flg';
import games from '../../_common/data/games';
import hdraces from '../../_common/data/hdraces';
import lang from '../../_common/data/lang';
import player from '../../_common/data/player';
import redpipe from '../../_common/data/redpipe';
import route from '../../_common/data/route';
import timezones from '../../_common/data/timezones';
import tvbet from '../../_common/data/tvbet';
import winnings from '../../_common/data/winnings';
import softgamings from '../../_common/data/softgamings';
import komplexbridge from '../../_common/data/komplexbridge';
import aviatrix from '../../_common/data/aviatrix';
import galaxsys from '../../_common/data/galaxsys';
import smartsoft from '../../_common/data/smartsoft';
import vegas from '../../_common/data/vegas';
import mascot from '../../_common/data/mascot';
import boldplay from '../../_common/data/boldplay';
import doubleChanceLotto from '../../_common/data/doubleChanceLotto';
import toto from '../../_common/data/toto';
import betconstruct from '../../_common/data/betconstruct';
import baas from '../../_common/data/baas';

// bulmasite data
import logoutModal from './data/modals/logout';
import history from './data/history';
import gameBanners from './data/game-banners';

const stateProviders = [
    bk,
    client,
    currencies,
    content,
    covid,
    flg,
    games,
    hdraces,
    lang,
    player,
    redpipe,
    route,
    timezones,
    tvbet,
    winnings,
    logoutModal,
    history,
    gameBanners,
    softgamings,
    komplexbridge,
    aviatrix,
    galaxsys,
    smartsoft,
    vegas,
    mascot,
    boldplay,
    doubleChanceLotto,
    toto,
    betconstruct,
    baas
];

let vuexState = {};
let getters = {};
let actions = {};
let mutations = {};

stateProviders.forEach(p => p.initVuex(vuexState, getters, actions, mutations));

const store = new Vuex.Store({
    state: vuexState,
    getters: getters,
    actions: actions,
    mutations: mutations
});

store.hasModule = name => {
    if (!name) return;
    if (!store._modules) return;
    if (!store._modules.root) return;
    if (!store._modules.root._children) return;
    
    return !!store._modules.root._children[name];
}
window.store = store;

let appState = {};
stateProviders.forEach(p => p.initAppState(appState, store));

export default Object.assign({ store }, appState);



// WEBPACK FOOTER //
// ./skins/bulmasite/state.js